<template>
  <a-drawer
    :visible="planVisible"
    title="查看计划单"
    width="656px"
    :mask-closable="false"
    class="single-plan"
    @close="onClose"
  >
    <div class="plan-info flex">
      <div>
        <p>计划单</p>
        <p class="plan-value">{{detail.planName}}</p>
      </div>
      <div class="plan-time">
        <p>确认时间</p>
        <p class="plan-value">{{detail.confirmTime}}</p>
      </div>
    </div>
    <a-table
      :columns="SINGLEPLANCOLUMN"
      :data-source="dataList"
      class="table-sigle"
      row-key="id"
    />
  </a-drawer>
</template>

<script>
import moment from 'moment'
import { SINGLEPLANCOLUMN } from '../const'

export default {
  name: 'SinglePlan',
  data() {
    return {
      planVisible: false,
      detail: {},
      SINGLEPLANCOLUMN,
      dataList: []
    }
  },
  methods: {
    show(record) {
      this.detail = record
      record.pendingInfo.map(item => {
        const listItem = item
        listItem.planTime = moment(item.planTime).format('YYYY-MM-DD')
        return listItem
      })
      this.dataList = record.pendingInfo || []
      this.planVisible = true
    },
    onClose() {
      this.planVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.single-plan {
  .plan-info {
    color: #323232;
    margin-bottom: 32px;
    > div {
      flex: 1;
    }
    .plan-time {
      margin-left: 24px;
    }
    .plan-value {
      font-weight: 500;
      margin-top: 6px;
    }
  }
}
</style>
